export const guessZone = (date) => {
  try {
    return date.toLocaleString('en-US', { timeZoneName: 'short' }).match(/[\w-+]+/g).pop()
  } catch (err) {
    return ''
  }
}
